export const isProjectRoute = (route: string): boolean => {
  return route.indexOf('project') != -1;
};
